export function sanitizeInscricao(tipoInscricao, value) {
  const raw = (value ?? "").toString();
  return Number(tipoInscricao) === 1
    ? raw.toUpperCase().replace(/[^A-Z0-9]/g, "")
    : raw.replace(/\D/g, "");
}

export function formatInscricao(tipoInscricao, value) {
  const clean = sanitizeInscricao(tipoInscricao, value);
  const tipo = Number(tipoInscricao);

  if (tipo === 1 && clean.length === 14) {
    return clean.replace(/^([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  }
  if (tipo === 2 && clean.length === 11) {
    return clean.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  }

  return value ?? "";
}

export function mensagemErroConsultaRFB(error) {
  return error?.response?.status === 400
    ? "CNPJ não encontrado na consulta automática da Receita Federal. Preencha os dados manualmente."
    : "Problemas de conexão ao servidor da RFB ou limite de consultas por minuto atingido ! Aguarde 1 minuto e tente novamente !";
}
